var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModifierDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 15C6.53125 15 6.23708 14.8913 5.9925 14.6739C5.74792 14.4565 5.62542 14.1948 5.625 13.8889V6.66667H5V5.55556H8.125V5H11.875V5.55556H15V6.66667H14.375V13.8889C14.375 14.1944 14.2527 14.4561 14.0081 14.6739C13.7635 14.8917 13.4692 15.0004 13.125 15H6.875ZM13.125 6.66667H6.875V13.8889H13.125V6.66667ZM8.125 12.7778H9.375V7.77778H8.125V12.7778ZM10.625 12.7778H11.875V7.77778H10.625V12.7778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifierDelete);
export default __webpack_public_path__ + "static/media/modifierDelete.df0f9d8cf956b509c601566648aba3d2.svg";
export { ForwardRef as ReactComponent };